import React, { useState } from 'react';
import './FacilitiesList.css';

const facilities = [
  { icon: '🍼', name: 'Nursing Room', desc: 'Private space with comfortable armchair & outlet', highlight: true },
  { icon: '👶', name: 'Changing Table', desc: 'Available in all restrooms', highlight: true },
  { icon: '🪑', name: 'High Chairs', desc: 'Multiple available in dining area', highlight: true },
  { icon: '🅿️', name: 'Family Parking', desc: 'Dedicated spots near entrance', highlight: false },
  { icon: '🗑️', name: 'Diaper Disposal', desc: 'Sanitary units in every restroom', highlight: false },
  { icon: '🚽', name: 'Baby Toilet', desc: 'Kid-size toilet in family washroom', highlight: false },
  { icon: '🍪', name: 'Kid-Friendly Menu', desc: 'Organic snacks & allergen info', highlight: false },
  { icon: '🎮', name: 'Play Area', desc: 'Supervised soft play zone', highlight: false },
  { icon: '♿', name: 'Stroller Access', desc: 'Wide aisles & ramp entry', highlight: false },
  { icon: '🔌', name: 'Charging Stations', desc: 'USB & outlets at every table', highlight: false },
  { icon: '🧴', name: 'Baby Supplies', desc: 'Emergency diapers & wipes available', highlight: false },
  { icon: '❄️', name: 'Bottle Warming', desc: 'Microwave & warm water available', highlight: false },
];

const safetyFeatures = [
  { icon: '🛡️', name: 'Childproofed', desc: 'Corners & outlets protected' },
  { icon: '🩺', name: 'First Aid', desc: 'Full kit & CPR-trained staff' },
  { icon: '📞', name: 'Emergency Ready', desc: 'Direct line to local services' },
  { icon: '👁️', name: 'Supervised', desc: 'Staff monitors play areas' },
];

const FacilitiesList = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedFacilities = showAll ? facilities : facilities.slice(0, 6);

  return (
    <div className="facilities-section">
      <h2 className="section-title">What this place offers</h2>
      
      <div className="facilities-grid">
        {displayedFacilities.map((facility, idx) => (
          <div key={idx} className={`facility-card ${facility.highlight ? 'facility-card--highlight' : ''}`}>
            <div className="facility-icon">{facility.icon}</div>
            <div className="facility-content">
              <span className="facility-name">{facility.name}</span>
              <span className="facility-desc">{facility.desc}</span>
            </div>
          </div>
        ))}
      </div>

      {!showAll && (
        <button className="show-all-btn" onClick={() => setShowAll(true)}>
          Show all {facilities.length} amenities
        </button>
      )}

      <div className="safety-section">
        <h3 className="safety-title">
          <span className="safety-icon">🛡️</span>
          Safety & Accessibility
        </h3>
        <div className="safety-grid">
          {safetyFeatures.map((feature, idx) => (
            <div key={idx} className="safety-card">
              <span className="safety-card-icon">{feature.icon}</span>
              <div className="safety-card-content">
                <span className="safety-card-name">{feature.name}</span>
                <span className="safety-card-desc">{feature.desc}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FacilitiesList;
